import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { KPIProvider } from './context/KPIContext';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { EmployeeChat } from './pages/employee/EmployeeChat';
import { HRDashboard } from './pages/hr/HRDashboard';
import { KPIBuilder } from './pages/hr/KPIBuilder';
import { MgmtDashboard } from './pages/mgmt/MgmtDashboard';
// Placeholder components for routes not yet fully implemented but required for navigation
const Placeholder = ({
  title
}: {
  title: string;
}) => <div className="flex items-center justify-center h-full min-h-[50vh] text-secondary" data-id="element-0">
    <div className="text-center" data-id="element-1">
      <h2 className="text-2xl font-bold text-white mb-2" data-id="element-2">{title}</h2>
      <p data-id="element-3">This feature is coming soon in the MVP.</p>
    </div>
  </div>;
function ProtectedRoute({
  children,
  allowedRoles
}: {
  children: React.ReactNode;
  allowedRoles?: string[];
}) {
  const {
    user,
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" data-id="element-4" />;
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Redirect to their appropriate dashboard if they try to access unauthorized route
    if (user.role === 'employee') return <Navigate to="/employee" data-id="element-5" />;
    if (user.role === 'hr') return <Navigate to="/hr/dashboard" data-id="element-6" />;
    if (user.role === 'management') return <Navigate to="/mgmt/dashboard" data-id="element-7" />;
    return <Navigate to="/login" data-id="element-8" />;
  }
  return <>{children}</>;
}
export function App() {
  return <AuthProvider data-id="element-9">
      <KPIProvider data-id="element-10">
        <Router data-id="element-11">
          <Routes data-id="element-12">
            <Route path="/login" element={<LoginPage data-id="element-14" />} data-id="element-13" />

            {/* Employee Routes */}
            <Route path="/employee" element={<ProtectedRoute allowedRoles={['employee']} data-id="element-16">
                  <AppLayout data-id="element-17">
                    <EmployeeChat data-id="element-18" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-15" />
            <Route path="/employee/forms" element={<ProtectedRoute allowedRoles={['employee']} data-id="element-20">
                  <AppLayout data-id="element-21">
                    <Placeholder title="My Forms" data-id="element-22" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-19" />

            {/* HR Routes */}
            <Route path="/hr/dashboard" element={<ProtectedRoute allowedRoles={['hr']} data-id="element-24">
                  <AppLayout data-id="element-25">
                    <HRDashboard data-id="element-26" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-23" />
            <Route path="/hr/kpi/builder" element={<ProtectedRoute allowedRoles={['hr']} data-id="element-28">
                  <AppLayout data-id="element-29">
                    <KPIBuilder data-id="element-30" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-27" />
            <Route path="/hr/kpi/:id" element={<ProtectedRoute allowedRoles={['hr']} data-id="element-32">
                  <AppLayout data-id="element-33">
                    <Placeholder title="KPI Detail View" data-id="element-34" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-31" />
            <Route path="/hr/forms/builder" element={<ProtectedRoute allowedRoles={['hr']} data-id="element-36">
                  <AppLayout data-id="element-37">
                    <Placeholder title="Form Builder" data-id="element-38" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-35" />

            {/* Management Routes */}
            <Route path="/mgmt/dashboard" element={<ProtectedRoute allowedRoles={['management']} data-id="element-40">
                  <AppLayout data-id="element-41">
                    <MgmtDashboard data-id="element-42" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-39" />
            <Route path="/mgmt/digest" element={<ProtectedRoute allowedRoles={['management']} data-id="element-44">
                  <AppLayout data-id="element-45">
                    <Placeholder title="Monthly Digest" data-id="element-46" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-43" />

            {/* Admin Routes */}
            <Route path="/admin/*" element={<ProtectedRoute allowedRoles={['admin']} data-id="element-48">
                  <AppLayout data-id="element-49">
                    <Placeholder title="Admin Portal" data-id="element-50" />
                  </AppLayout>
                </ProtectedRoute>} data-id="element-47" />

            <Route path="/" element={<Navigate to="/login" data-id="element-52" />} data-id="element-51" />
          </Routes>
        </Router>
      </KPIProvider>
    </AuthProvider>;
}